import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RainUploadJob } from '../models/upload-job';

@Component({
  selector: 'app-rain-jobs-table',
  templateUrl: './rain-jobs-table.component.html',
  styleUrls: ['./rain-jobs-table.component.css']
})
export class RainJobsTableComponent implements OnInit {

  /** Colunas da tabela dos jobs de carregamento de chuva. */
  rainUploadTableColumns = [
    'stationName',
    'startTime', 
    'importEndTime', 
    'calcEndTime',
    'status',
    'action',
  ];

  /** Status do job que indicam que ele está sendo executado. */
  runningStatuses = ['COPIA', 'IMPORTACAO', 'CALCULO'];

  /** Linhas da tabela do histórico de jobs. */
  @Input() rows: RainUploadJob[] = [];

  /** Emissor do evento de cancelamento de um job ativo. */
  @Output() cancel = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Emite evento de cancelamento de um job
   * @param element 
   */
  cancelUpload(element: RainUploadJob) {
    this.cancel.emit(element);
  }
}
